import { TbArrowUp } from "react-icons/tb";

export const FooterBottom = () => {
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="bg-blueShades-7">
      <div className="py-5 px-4 md:px-16">
        <div className="flex justify-between items-center gap-4 referral-container">
          <p className="text-[10px] md:text-sm text-blueShades-6 font-SatoshiMedium">
            © {new Date().getFullYear()} Bankolé. All rights reserved
          </p>

          <button
            onClick={handleScrollTop}
            className="flex items-center gap-1 cursor-pointer"
          >
            <p className="text-[10px] md:text-sm text-blueShades-6 font-SatoshiMedium">
              Back to top
            </p>
            <TbArrowUp />
          </button>
        </div>
      </div>
    </div>
  );
};
